import { render, staticRenderFns } from "./SecaoParceiros.vue?vue&type=template&id=4504fc7c&"
import script from "./SecaoParceiros.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoParceiros.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports